module.exports = __webpack_public_path__ + "img/type3_default.261297e9.png";